import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  auth: {
    authority:
      'https://testulplatform.b2clogin.com/testulplatform.onmicrosoft.com/b2c_1a_signup_signin_staging/v2.0/',
    clientId: '8c336d8b-a49e-4df6-9ffe-a857ae72177b',
    scope:
      'openid offline_access https://testulplatform.onmicrosoft.com/stages-companion-dev/access',
    logLevel: LogLevel.Debug,
    adminOrgConfig: 'b8e7094c-1ee5-4613-af7f-a8e10e555d12',
  },
};
